import { CreateConfig, BaseClient } from '@carvana/analytics';
import startTracking from '@carvana/analytics-clickstream';
import GoogleTagManagerClient from '@carvana/analytics-google-tag-manager';
import { isClient } from '../is-client';
import { canIUseApi } from '../can-i-use-api';

const getUtmsFromUrl = ({ search } = {}) => {
  try {
    if (!search) return null;
    const params = new URLSearchParams(search);

    return Array.from(params.keys()).reduce(
      (acc, val) =>
        val?.toLowerCase()?.includes('utm') ? { ...acc, [val]: params.get(val) } : acc,
      {}
    );
  } catch (error) {
    return null;
  }
};

const getSessionIdFromLocalStorage = () => {
  if (!canIUseApi('sessionStorage')) return;

  return sessionStorage.getItem('support-center-session-id');
};
export class ClickStreamTracker extends BaseClient {
  constructor(config) {
    super('clickstream', config);
    this.track = isClient()
      ? startTracking(process.env.GATSBY_CLICKSTREAM_ANALYTICS_URL, 'core', 'support_center')
      : () => {};
  }

  static SetCommonData = (data) => {
    ClickStreamTracker.commonData = { ...ClickStreamTracker.commonData, ...data };
  };

  trackEvent = async (eventName, eventData, log, noPublish) => {
    if (!isClient()) return null;

    const postData = {
      ...eventData,
      previous_site: document.referrer,
      utm: getUtmsFromUrl(window.location),
      support_center_session_id: getSessionIdFromLocalStorage(),
      ...ClickStreamTracker?.commonData
    };

    if (log) {
      log(`[Analytics_ClickStreamTracker_Event -- ${eventName}]`, postData);
    }

    if (!noPublish) {
      this.track({
        custom_attributes: {
          ...postData
        },
        event_source_context: {
          event_source: 'page',
          event_action: 'none',
          event_name: eventName,
          event_source_name: 'page',
          event_source_id: 'core-support_center',
          event_datetime: new Date()
        }
      });
    }
  };
}

export const AnalyticConfig = new CreateConfig({
  clickstream: new ClickStreamTracker({}),
  gtm: new GoogleTagManagerClient({
    id: process.env.GATSBY_GTM_ID
  }),
  debug: process.env.GATSBY_ENV === 'non-prod',
  noPublish: process.env.NODE_ENV === 'development'
});
